import * as React from "react";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import URI from "urijs";
import Spinner from "components/common/Spinner";
import { Alert } from "components/bootstrap";
import fetch from "logic/rest/FetchProvider";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
import useHistory from "routing/useHistory";
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 200px;
`;
const MISSING_STEP_ID_ERROR = "The event procedure link is missing the required step identifier.";
const buildBackendUrl = (stepId, eventId) => {
  const stepParam = `stepId=${stepId}`;
  const eventParam = eventId ? `&eventId=${eventId}` : "";
  const params = stepParam + eventParam;
  return qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.executeAction(params).url);
};
const ExecuteEventProcedureActionPage = () => {
  const [searchParams] = useSearchParams();
  const [executionError, setExecutionError] = useState(null);
  const [redirecting, setRedirecting] = useState(false);
  const history = useHistory();
  const stepId = searchParams.get("stepId");
  const eventId = searchParams.get("eventId");
  useEffect(() => {
    let cancelled = false;
    if (!stepId) {
      return void 0;
    }
    fetch("GET", buildBackendUrl(stepId, eventId)).then((response) => {
      if (cancelled) {
        return;
      }
      const redirectUri = response == null ? void 0 : response.redirect_uri;
      if (!redirectUri) {
        setExecutionError("The event procedure action responded without a redirect location.");
        return;
      }
      const redirectPath = new URI(redirectUri).resource();
      setRedirecting(true);
      history.replace(redirectPath);
    }).catch((actionError) => {
      var _a;
      if (cancelled) {
        return;
      }
      const message = ((_a = actionError == null ? void 0 : actionError.additional) == null ? void 0 : _a.message) || (actionError == null ? void 0 : actionError.message) || "Failed to execute the event procedure action.";
      setExecutionError(message);
    });
    return () => {
      cancelled = true;
    };
  }, [stepId, eventId, history]);
  const error = stepId ? executionError : MISSING_STEP_ID_ERROR;
  if (error) {
    return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, error));
  }
  const spinnerText = redirecting ? "Redirecting to the target..." : "Executing event procedure action...";
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Spinner, { text: spinnerText, delay: 0 }));
};
export default ExecuteEventProcedureActionPage;
